<template>
  <div>
    <div class="v-spinner spinner-centrado" v-show="loading" v-if="propLoading">   
        <div
        class="v-sync v-sync1"
        v-bind:style="[spinnerStyle, spinnerDelay1]"
        ></div>
        <div
        class="v-sync v-sync2"
        v-bind:style="[spinnerStyle, spinnerDelay2]"
        ></div>
        <div
        class="v-sync v-sync3"
        v-bind:style="[spinnerStyle, spinnerDelay3]"
        ></div>
    </div>

    <!-- ✅ MODAL DE AVISO CENTRYA - idEmpresa = 1 (Facilísimo) e idEmpresa = 2 (Apostar) -->
    <v-dialog
        v-model="mostrarModalCentrya"
        max-width="500"
        persistent
        overlay-color="#0a0a1a"
        overlay-opacity="0.88"
    >
        <v-card class="centrya-modal-card" elevation="0">
            <div class="centrya-alert-header">
                <div class="centrya-alert-icon-wrap">
                    <v-icon size="40" color="#ffffff">mdi-alert-decagram</v-icon>
                </div>
                <div class="centrya-header-texts">
                    <span class="centrya-header-title">Plataforma inhabilitada</span>
                    <span class="centrya-header-sub">Aviso importante para asesores {{ nombreEmpresaCentrya }}</span>
                </div>
            </div>
            <v-card-text class="centrya-body">
                <p class="centrya-desc">
                    Esta plataforma ha sido <strong>inhabilitada</strong> para la recepción de tickets.
                    A partir de ahora, todas las solicitudes deben gestionarse a través de
                    <strong>Centrya</strong>, el nuevo Portal Administrativo de {{ nombreEmpresaCentrya }}.
                </p>
                <div class="centrya-info-box">
                    <v-icon small color="#c8102e" style="margin-right:6px">mdi-information-outline</v-icon>
                    <span>Haz clic en <strong>"Ver guía Centrya"</strong> para ver las instrucciones de uso del nuevo portal.</span>
                </div>
            </v-card-text>
            <v-card-actions class="centrya-actions">
                <v-btn
                    depressed
                    class="centrya-btn-back"
                    @click="regresarAlMenu"
                >
                    <v-icon left small>mdi-arrow-left</v-icon>
                    Regresar al menú
                </v-btn>
                <v-btn
                    depressed
                    class="centrya-btn-go"
                    @click="abrirPdf"
                >
                    <v-icon left small>mdi-file-pdf-box</v-icon>
                    Ver guía Centrya
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>

    <div id="inspire" class="fuente" v-if="!propLoading">
        <v-toolbar class="nav" dense="">
        <v-spacer></v-spacer>
        <v-btn class="blue-grey darken-3 mr-3" dark small @click="logout">
            SIREP
            <v-icon>mdi-backburger</v-icon>
        </v-btn>
        </v-toolbar>
        <v-container fluid fill-height>
            <v-layout> 
                <v-flex xs12 sm2 md2>
                <v-navigation-drawer 
                    class="drawer" 
                    v-model="drawer" 
                    :temporary="isMobileOrTablet"
                    absolute
                    :permanent="!isMobileOrTablet"
                    :width="280"
                    :overlay-opacity="0"
                    :hide-overlay="true"
                >
                    <div v-if="isMobileOrTablet" class="close-button-container">
                    <v-btn
                        icon
                        @click="drawer = false"
                        class="close-btn"
                        color="white"
                    >
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                    </div>
                    <div class="fondo-con-logo">
                        <v-img
                        class="fondo"
                        :src="require('../../.././assets/PANTALLA-03.png')"
                        contain
                        ></v-img>
                        <v-img
                        class="logo"
                        :src="require('../../.././assets/nova/NOMBREBLANCO.png')"
                        max-height="100"
                        contain
                        ></v-img>
                    </div>
                    <v-list dense>
                        
                    <div class="name">{{nombre}}</div>
                        <v-list-item-group color="#294697">
                        <v-list-item
                        :to="itemInicio.link"
                        @click="handleNavigation"
                        >
                            <v-list-item-icon>
                            <v-icon>{{itemInicio.icon}}</v-icon>
                            </v-list-item-icon>

                            <v-list-item-content>
                            <v-list-item-title>{{itemInicio.text}}</v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        <v-list-item
                            @click="closeModule">
                            <v-list-item-icon>
                            <v-icon>mdi-power-standby</v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                            <v-list-item-title @click="logout"
                            >CERRAR MODULO</v-list-item-title
                            >
                            </v-list-item-content>
                        </v-list-item>

                        </v-list-item-group>
                    </v-list>
                </v-navigation-drawer>
                </v-flex>
                <v-flex xs12 sm10 md10>
                <v-main>
                    <v-container id="myresponsiveEspecialista">
                    <router-view  to="children"/>
                    </v-container>
                </v-main>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
  </div>
</template>
<script>
    import axios from "axios";
    import env from "../../env";
    export default {
    name: "SyncLoader",
    props: {
        loading: {
            type: Boolean,
            default: true,
        },
        color: {
            type: String,
            default: "#1b4695",
        },
        size: {
            type: String,
            default: "30px",
        },
        margin: {
            type: String,
            default: "2px",
        },
        radius: {
            type: String,
            default: "100%",
        },
    },
    data() {
        return {
            propLoading: this.loading,
            nombre: localStorage.getItem("nombre"),
            id: localStorage.getItem("id"),
            idCargo: localStorage.getItem("idCargo"),
            drawer: true,
            // Modal Centrya
            mostrarModalCentrya: true,
            urlPdf: '/centrya/guia-centrya-facilisimo.pdf',
            nombreEmpresaCentrya: 'Facilísimo',
            itemInicio: { text: "DESENROLAMIENTO", icon: "mdi-fingerprint",  link: "/Callcenter/FormCasos" },
            items: [
                {
                    text: "DESENROLAMIENTO",
                    icon: "mdi-fingerprint",
                    link: "/Callcenter/FormCasos/Inicio",
                },
            ],
            spinnerStyle: {
                backgroundColor: this.color,
                height: this.size,
                width: this.size,
                margin: this.margin,
                borderRadius: this.radius,
                display: "inline-block",
                animationName: "v-syncStretchDelay",
                animationDuration: "0.6s",
                animationIterationCount: "infinite",
                animationTimingFunction: "ease-in-out",
                animationFillMode: "both",
            },
            spinnerDelay1: {
                animationDelay: "0.07s",
            },
            spinnerDelay2: {
                animationDelay: "0.14s",
            },
            spinnerDelay3: {
                animationDelay: "0.21s",
            },
        };
    },
    computed: {
        isMobile() {
            return this.$vuetify.breakpoint.xs;
        },
        isTablet() {
            return this.$vuetify.breakpoint.sm || this.$vuetify.breakpoint.md || this.$vuetify.breakpoint.lg;
        },
        isMobileOrTablet() {
            return this.isMobile || this.isTablet;
        }
    },
    methods: {
        // metodo par cerrar sesión y remover los datos del localStorage
        logout() {
            this.$router.push("/user");
        },
        closeModule() {
            window.close();
        },
        handleNavigation() {
            if (this.isMobileOrTablet) {
                this.drawer = false;
            }
        },
        // --- Modal Centrya ---
        detectarEmpresa() {
            const idEmpresaRaw = localStorage.getItem('idEmpresa');
            const idEmpresa = idEmpresaRaw !== null && !isNaN(parseInt(idEmpresaRaw, 10))
                ? parseInt(idEmpresaRaw, 10)
                : null;

            console.log('📌 DashboardFormCase - Centrya Modal - idEmpresa detectado:', idEmpresa, '(raw:', idEmpresaRaw, ')');

            if (idEmpresa === 2) {
                this.nombreEmpresaCentrya = 'Apostar';
                this.urlPdf = '/centrya/guia-centrya-apostar.pdf';
            } else {
                // Facilísimo por defecto o si idEmpresa === 1
                this.nombreEmpresaCentrya = 'Facilísimo';
                this.urlPdf = '/centrya/guia-centrya-facilisimo.pdf';
            }
            this.mostrarModalCentrya = true;
        },
        regresarAlMenu() {
            this.mostrarModalCentrya = false;
            this.$router.push('/user');
        },
        abrirPdf() {
            window.open(this.urlPdf, '_blank');
        },
    },
    created() {
        this.detectarEmpresa();
    },
    mounted() {
        this.detectarEmpresa();
        setTimeout(() => {
            this.propLoading = false;
            this.detectarEmpresa();
        }, 1000);
    },
    };
</script>

<style>
.fondo-con-logo {
  position: relative;
  width: 100%;
  height: 250px; 
  background-color: #294697;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
}

.fondo-con-logo .fondo {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: contain;
  z-index: 1;
}

.fondo-con-logo .logo {
  position: relative;
  z-index: 2;
}
.drawer {
  z-index: 1000 !important;
}
.close-button-container {
  position: absolute;
  top: 10px;
  right: 10px;
  z-index: 1001;
}
.close-btn {
  background-color: rgba(0, 0, 0, 0.3) !important;
  border-radius: 50%;
}

@media (max-width: 1000px) {
  #myresponsiveEspecialista {
    position: fixed;
    top: 45px;
    left: -30px;
    max-width: 550px;
  }
}

@media (min-width: 600px) and (max-width: 1024px) {
  #myresponsiveEspecialista {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
    padding: 16px;
  }
}

@media (min-width: 1025px) {
  #myresponsiveEspecialista {
    position: relative;
    top: 0;
    left: 0;
    max-width: 100%;
  }
}

/* =============================================
   ESTILOS MODAL CENTRYA
   ============================================= */
.centrya-modal-card {
  border-radius: 16px !important;
  overflow: hidden;
  background: #ffffff !important;
  border: none;
}

/* Encabezado rojo de alerta */
.centrya-alert-header {
  background: linear-gradient(135deg, #c8102e 0%, #8b0000 100%);
  padding: 24px 28px;
  display: flex;
  align-items: center;
  gap: 16px;
}

.centrya-alert-icon-wrap {
  background: rgba(255,255,255,0.18);
  border-radius: 50%;
  width: 60px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  border: 2px solid rgba(255,255,255,0.35);
}

.centrya-header-texts {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.centrya-header-title {
  font-size: 1.2rem;
  font-weight: 800;
  color: #ffffff;
  letter-spacing: 0.3px;
  line-height: 1.2;
}

.centrya-header-sub {
  font-size: 0.78rem;
  color: rgba(255,255,255,0.75);
  font-weight: 400;
  letter-spacing: 0.2px;
}

.centrya-body {
  padding: 24px 28px 8px !important;
}

.centrya-desc {
  font-size: 0.95rem;
  color: #333;
  line-height: 1.65;
  margin: 0 0 16px 0;
}

.centrya-info-box {
  background: #fff3f3;
  border-left: 3px solid #c8102e;
  border-radius: 6px;
  padding: 10px 14px;
  display: flex;
  align-items: flex-start;
  font-size: 0.84rem;
  color: #555;
  line-height: 1.5;
}

.centrya-actions {
  display: flex !important;
  justify-content: space-between !important;
  padding: 12px 28px 24px !important;
  gap: 12px;
}

.centrya-btn-back {
  flex: 1;
  background: #f1f1f1 !important;
  color: #444 !important;
  font-weight: 600;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 0.9rem !important;
  height: 44px !important;
  transition: background 0.2s;
}

.centrya-btn-back:hover {
  background: #e0e0e0 !important;
}

.centrya-btn-go {
  flex: 1;
  background: linear-gradient(135deg, #c8102e 0%, #a00020 100%) !important;
  color: #ffffff !important;
  font-weight: 700;
  border-radius: 10px !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  font-size: 0.9rem !important;
  height: 44px !important;
  box-shadow: 0 4px 14px rgba(200, 16, 46, 0.35) !important;
  transition: box-shadow 0.2s, transform 0.15s;
}

.centrya-btn-go:hover {
  box-shadow: 0 6px 20px rgba(200, 16, 46, 0.5) !important;
  transform: translateY(-1px);
}
</style>
